"use client";

import { Box, Grid, Link, Typography, Button } from "@mui/material";
import { pxToVw } from "@/utils/pxToVw";
import Image from "next/image";
import { MOBILE_BASE } from "@/theme/theme";
import { useText } from "@/context/TextContext";

export default function LloguerSection() {
  return (
    <Grid
      container
      spacing={{ xs: pxToVw(0, MOBILE_BASE), md: pxToVw(0) }}
      size={12}
      mb={{ xs: pxToVw(80, MOBILE_BASE), md: pxToVw(160.5) }}
    >
      {/* Columna 1 */}
      <Grid container size={{ xs: 12, md: 6 }} position={"relative"}>
        <Box display={{ xs: "none", md: "flex" }} width={"100%"}>
          <Image
            src={useText("lloguer.image.principal")}
            alt="Lloguer"
            width={696}
            height={900}
            style={{
              width: "100%",
              height: "auto",
            }}
          />
        </Box>
        <Box display={{ xs: "flex", md: "none" }} width={"100%"}>
          <Image
            src={useText("lloguer.image.principal")}
            alt="Lloguer"
            width={363}
            height={503}
            style={{
              width: "100%",
              height: "auto",
            }}
          />
        </Box>
      </Grid>
      {/* Columna 2 */}
      <Grid
        container
        size={{ xs: 12, md: 6 }}
        position={"relative"}
        bgcolor={"#472600"}
        //reverse column on mobile
        flexDirection={{ xs: "column-reverse", md: "column" }}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Box
          position={{ xs: "inherit", md: "absolute" }}
          bottom={{ xs: "inherit", md: pxToVw(30) }}
          width={{ xs: "inherit", md: "100%" }}
          height={{ xs: "inherit", md: "100%" }}
          display={{ xs: "inherit", md: "flex" }}
          alignItems={{ xs: "inherit", md: "center" }}
          textAlign={{ xs: "inherit", md: "center" }}
          justifyContent={{ xs: "inherit", md: "flex-end" }}
          gap={{ xs: pxToVw(0, MOBILE_BASE), md: pxToVw(30) }}
          flexDirection={{ xs: "inherit", md: "column" }}
        >
          <Typography
            variant="body3"
            color="warm1"
            textAlign={"center"}
            ml={pxToVw(54)}
            mr={pxToVw(54)}
            mt={{ xs: pxToVw(202, MOBILE_BASE), md: "initial" }}
            pb={{ xs: pxToVw(30, MOBILE_BASE), md: "initial" }}
            fontSize={{ xs: pxToVw(16, MOBILE_BASE), md: pxToVw(16) }}
            lineHeight={{ xs: "115%", md: "110%" }}
          >
            {useText("lloguer.slide.text")}
          </Typography>
        </Box>
        <Box
          position={{ xs: "inherit", md: "absolute" }}
          top={{ xs: "inherit", md: pxToVw(0) }}
          left={{ xs: "inherit", md: pxToVw(0) }}
          width={{ xs: "inherit", md: "100%" }}
          height={{ xs: "inherit", md: "100%" }}
          display={{ xs: "inherit", md: "flex" }}
          alignItems={{ xs: "inherit", md: "center" }}
          justifyContent={{ xs: "inherit", md: "center" }}
          textAlign={{ xs: "inherit", md: "center" }}
          gap={{ xs: pxToVw(0, MOBILE_BASE), md: pxToVw(30) }}
          flexDirection={{ xs: "column", md: "column" }}
          pt={{ xs: pxToVw(30, MOBILE_BASE), md: "initial" }}
        >
          <Typography
            variant="titulo"
            color="warm1"
            textAlign={"center"}
            component="h1"
            sx={{ textTransform: "uppercase" }}
            mb={{ xs: pxToVw(20, MOBILE_BASE), md: "initial" }}
            whiteSpace={"pre-wrap"}
          >
            {useText("lloguer.slide.caption")}
          </Typography>
          <Button
            variant="botonWarm1"
            color="warm1"
            href={useText("lloguer.slide.button.url")}
            sx={{
              "&:hover": {
                backgroundColor: "#D4D1C8",
                color: "#472600",
              },
            }}
          >
            {useText("lloguer.slide.button.text")}
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}
